export interface CursorPaging {
  limit?: number;
  cursor?: string;
}

export interface Paging {
  offset?: number;
  limit?: number;
  total?: number;
  next?: string;
}

export interface ListResponse<T> {
  data: T[];
  paging: Paging;
}

export interface GetResponse<T> {
  data: T;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export interface _Action {
  _name: string;
  _method: string;
  _href: string;
  _title: string;
  _fields: _Field[];
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export interface _Field {
  _name: string;
  _title: string;
  _type: string;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export interface _Link {
  _rel: string[];
  _href: string;
}

export interface ViError {
  viErrorId: string;
  statusCode: number;
  errorType: string;
  message: string;
  extendedPayload?: {
    code: string;
    details: string;
    reason: string;
    errorType?: string;
    errorMessage?: string;
  };
  privateDetails: ErrorPrivateDetails;
  validationErrors?: string[];
}

export interface ErrorPrivateDetails {
  service: string;
  originResponseBody: ErrorOriginResponseBody;
}

export interface ErrorOriginResponseBody {
  error: string;
  errorData: any;
}

export enum ErrorType {
  RESOURCE_NOT_FOUND = 'RESOURCE_NOT_FOUND',
  EQUIPMENT_ID_NOT_FOUND_FOR_BOILER_ID = 'EQUIPMENT_ID_NOT_FOUND_FOR_BOILER_ID',
}

export enum ResponseType {
  arrayBuffer = 'arraybuffer',
  blob = 'blob',
  json = 'json',
  text = 'text',
}

export enum VoucherValidationErrorResponse {
  INVALID_VOUCHER_CODE = 'INVALID_VOUCHER_CODE',
  INVALID_VOUCHER_TYPE = 'INVALID_VOUCHER_TYPE',
  VOUCHER_ALREADY_USED = 'VOUCHER_ALREADY_USED',
  WRONG_VOUCHER_CODE = 'Wrong voucher code',
}
